import moment from "moment";

export function normalizeWorklogUserIds(users = []) {
  return (users || [])
    .map((item) => item?.user_id)
    .filter((value) => value !== undefined && value !== null && value !== "")
    .map(String)
    .sort();
}

export function normalizeArrayValues(values = []) {
  return (values || [])
    .filter((value) => value !== undefined && value !== null && value !== "")
    .map(String)
    .sort();
}

export function normalizeWorklogDateRange(dateRange) {
  if (!dateRange?.startDate || !dateRange?.endDate) {
    return null;
  }

  return {
    startDate: moment(dateRange.startDate).format("YYYY-MM-DD"),
    endDate: moment(dateRange.endDate).format("YYYY-MM-DD"),
  };
}
